export default "__VITE_ASSET__CbuNEd27__"